import React from 'react';
import { Layout as RALayout, AppBar, UserMenu, useGetIdentity } from 'react-admin';
import { Typography, Box } from '@mui/material';

const CustomAppBar = (props: any) => {
  const { identity } = useGetIdentity();
  
  return (
    <AppBar {...props} userMenu={<UserMenu />}>
      <Box flex="1" display="flex" alignItems="center">
        <Typography variant="h6" color="inherit">
          🏆 Atleta Network Admin Panel
        </Typography>
      </Box>
      {identity && (
        <Typography variant="body2" color="inherit" sx={{ marginRight: 2 }}>
          Welcome, {identity.fullName}
        </Typography>
      )}
    </AppBar>
  );
};

export const Layout = (props: any) => <RALayout {...props} appBar={CustomAppBar} />;
